module.exports = __webpack_public_path__ + "img/Astronaut.7322a5b1.svg";